import { useState } from "react"
import { CVFile } from "../interface/CV_types"
import { TrashIcon } from "lucide-react"
import { OrangeButton } from "@/components/Buttons"
import { delete_file } from "../api/cloud_viewer"

export function DeleteButton({file, project_id}: {file: CVFile, project_id: string}) {
    const [isDeleting, setIsDeleting] = useState(false)

    const handleDelete = async () => {
        setIsDeleting(true)

        // Delete the file
        const confirmed = confirm("Are you sure you want to delete this file? This action cannot be undone.")

        if (confirmed) {
            const response = await delete_file(project_id, file.name)
            if (response.status === 200) {
                alert("File deleted successfully")
                window.location.reload()
            } else {
                alert("Error deleting file")
            }

            setIsDeleting(false)
        }
        else {
            setIsDeleting(false)
        }
    }

    return (
            <OrangeButton onClick={handleDelete} disabled={isDeleting}>
                {isDeleting ? "Deleting..." : <TrashIcon className="w-4 h-4" />}
            </OrangeButton>
    )
}
